import { Link } from "wouter";
import { Loader2, SearchX } from "lucide-react";

export function DetailLoading({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="container-x py-24 text-center text-mut">
      <Loader2 className="w-6 h-6 animate-spin mx-auto mb-3 text-navy" />
      {label}
    </div>
  );
}

export function DetailNotFound({ title, backHref = "/marketplace", backLabel = "Back to Marketplace" }: {
  title: string; backHref?: string; backLabel?: string;
}) {
  return (
    <div className="container-x py-24 text-center">
      <SearchX className="w-10 h-10 text-mut mx-auto mb-3" />
      <h1 className="text-2xl font-extrabold text-navy">{title}</h1>
      <p className="text-mut mt-1">It may have been removed or the link is incorrect.</p>
      <Link href={backHref} className="btn-navy mt-5 inline-flex">{backLabel}</Link>
    </div>
  );
}
